// src/components/Header.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';

export default function Header({ backgroundImageUrl, subtitle }) {
const navigate = useNavigate();

const handleClickChatbot = () => { window.open('https://dev.entrosystem.com', '_blank'); };
const handleClickTechnology = () => { navigate('/technology'); };
const handleClickAbout = () => { navigate('/about'); };
const handleClickHome = () => { navigate('/'); };
const handleClickRepository = () => { navigate('/repos'); };

const headerStyle = {
// backgroundImage: `url(${backgroundImageUrl})`,
// backgroundPosition: 'center 30%',
};

return (
// The main header container gets the background image and base styles
<header className={styles.headerContainer} style={headerStyle}>
	{/* The overlay handles the dark tint and the new flexbox layout */}
	<div className={styles.headerOverlay}>
	
		{/* The navbar will now be a flex item at the top of the header */}
		<nav className={styles.navbar}>
			{/* Using an <h1> for the logo is better for SEO and semantics */}
			<div className={styles.logoContainer}>
				<h1 className={styles.logo} onClick={handleClickHome}>
					ENTROSYSTEM
				</h1>
				<div className={styles.logoSubtitle}>AI • ENGINEERING • SCIENCE</div>
			</div>
			<div className={styles.links}>
				<div onClick={handleClickTechnology}>BLOG</div>
				<div onClick={handleClickRepository}>REPOSITORY</div>
				{/* <div onClick={handleClickChatbot}>CHATBOT</div> */}
				<div onClick={handleClickAbout}>ABOUT</div>
			</div>
		</nav>

		{/* The subtitle is rendered as the second flex item */}
		{subtitle && (
			<div className={styles.headerContent}>
			<p>{subtitle}</p>
			</div>
		)}
	</div>
</header>
);
}